import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: JSON.parse(sessionStorage.getItem("filters") || "{}") || undefined,
}

const filter = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilter: (state, action) => {
        const key = action.payload.key;
        const value = action.payload.value;
        state.filters = { ...state.filters, [key]: value };
        sessionStorage.setItem("filters", JSON.stringify(state.filters));
    },

    resetFilters: (state) => {
      state.filters = undefined;
      sessionStorage.removeItem("filters");
    },
   
  },
});

export const { setFilter, resetFilters } = filter.actions;
export default filter.reducer;